<template>
  <div>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 lg:col-span-12">
        <!-- BEGIN: Bordered Table -->
        <div class="intro-y box mt-5">
          <div
            v-if="$h.isset(this.$store.state.auth.user)"
            class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
          >
            <div class="w-full sm:w-auto flex items-center justify-center">
              <h2
                v-if="$store.state.auth.user.isAdmin == 0"
                class="font-medium text-base mr-auto"
              >
                {{ this.$store.state.auth.user.agencyName }}
              </h2>
              <select
                v-if="$store.state.auth.user.isAdmin >= 1"
                v-model="agencyId"
                type="text"
                class="input input--lg border w-full lg:w-auto mt-3 lg:mt-0"
                style="padding-bottom: 0.6rem !important; papdding-top: 0.6rem !important;"
                @change="getHandMoney()"
              >
                <option value="">전체</option>
                <option
                  v-for="(agency, index) in agencies"
                  :key="index"
                  :value="agency.id"
                >
                  <h2 class="font-medium text-base mr-auto">
                    {{ agency.name }}
                  </h2>
                </option>
              </select>
            </div>
            <div class="w-full sm:w-auto flex items-center justify-between">
              <el-date-picker
                v-if="$store.state.auth.user.isAdmin >= 1"
                v-model="todayStatisticQuery.selectedDay"
                type="date"
                placeholder="일별"
                value-format="yyyy-MM-dd"
                :picker-options="deletedPeriodPickerOptions"
                class="flex w-24 inline-block mt-3 sm:ml-4 sm:mt-0"
                @change="getHandMoney()"
              >
              </el-date-picker>
              <div class="sm:w-auto flex items-center ml-4 mt-3 sm:mt-2">
                <button
                  class="button w-24 mr-1 mb-2 bg-theme-12 text-white"
                  @click="exportExcel()"
                >
                  엑셀출력
                </button>
              </div>
            </div>
          </div>
          <div id="bordered-table" class="p-5">
            <div class="preview">
              <div class="overflow-x-auto">
                <table class="table">
                  <thead>
                    <tr>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        외화
                      </th>
                      <th
                        v-for="(handMoney, index) in handMoneys"
                        :key="index"
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        {{ handMoney.country }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="border dark:border-dark-5 text-center">
                        현재 시재금
                      </td>
                      <td
                        v-for="(handMoney, index) in handMoneys"
                        :key="index"
                        class="border dark:border-dark-5 text-center"
                      >
                        {{ handMoney.unit }}
                        {{ $h.filterCurrency(handMoney.handForeignAmount) }}
                      </td>
                    </tr>
                    <tr>
                      <td class="border dark:border-dark-5 text-center">
                        평단가
                      </td>
                      <td
                        v-for="(handMoney, index) in handMoneys"
                        :key="index"
                        class="border dark:border-dark-5 text-center"
                      >
                        {{ $h.filterCurrency(handMoney.averageCost) }}
                      </td>
                    </tr>
                    <tr v-if="$store.state.auth.user.isAdmin >= 1">
                      <td class="border dark:border-dark-5 text-center">
                        환산액(원화)
                      </td>
                      <td
                        v-for="(handMoney, index) in handMoneys"
                        :key="index"
                        class="border dark:border-dark-5 text-center"
                      >
                        ₩
                        {{
                          $h.filterCurrency(
                            parseInt(
                              handMoney.handForeignAmount *
                                handMoney.averageCost
                            )
                          )
                        }}
                      </td>
                    </tr>
                    <tr v-if="$store.state.auth.user.isAdmin >= 1">
                      <td
                        class="border dark:border-dark-5 text-center"
                        colspan="2"
                      >
                        이종통화 합계
                      </td>
                      <td
                        class="border dark:border-dark-5 text-center"
                        colspan="17"
                      >
                        ₩
                        {{ $h.filterCurrency(usdExtrAmount) }}
                      </td>
                    </tr>
                    <tr v-if="$store.state.auth.user.isAdmin >= 1">
                      <td class="border dark:border-dark-5 text-center">
                        원화
                      </td>
                      <td class="border dark:border-dark-5" colspan="18">
                        <div class="flex items-center mt-3 ml-10 mb-8">
                          <div>
                            <div class="text-center p-2">
                              원화
                            </div>
                            <div
                              class="border dark:border-dark-5 whitespace-no-wrap text-center p-5"
                            >
                              ₩
                              {{ $h.filterCurrency(totalLocalAmount) }}
                            </div>
                          </div>
                          <div class="px-5 mt-10">+</div>
                          <div>
                            <div class="text-center p-2">
                              통장잔고
                            </div>
                            <div
                              class="border dark:border-dark-5 whitespace-no-wrap text-center p-5"
                            >
                              ₩
                              {{ $h.filterCurrency(totalBankAmount) }}
                            </div>
                          </div>
                          <div class="px-5 mt-10">=</div>
                          <div>
                            <div class="text-center p-2">
                              합계
                            </div>
                            <div
                              class="border dark:border-dark-5 whitespace-no-wrap text-center p-5"
                            >
                              ₩
                              {{
                                $h.filterCurrency(
                                  Number(totalLocalAmount) +
                                    Number(totalBankAmount)
                                )
                              }}
                            </div>
                          </div>
                          <div class="ml-auto">
                            <div class="text-center p-2">
                              시재금 총계
                            </div>
                            <div
                              class="border dark:border-dark-5 whitespace-no-wrap text-center p-5"
                            >
                              ₩
                              {{ $h.filterCurrency(totalAmount) }}
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Bordered Table -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { export_json_to_excel } from "@/assets/js/vendor/Export2Excel";

export default {
  data() {
    return {
      agencies: [],
      totalLocalAmount: 0,
      totalBankAmount: 0,
      usdExtrAmount: 0,
      totalAmount: 0,
      handMoneys: [],
      agencyId: "",
      todayStatisticQuery: {
        selectedDay: "",
        selectedMonth: "",
        loading: false
      }
    };
  },
  async mounted() {
    await this.tokenLogin();
    this.todayStatisticQuery.selectedDay = moment(new Date()).format(
      "YYYY-MM-DD"
    );
    this.getAgencies();
    this.getHandMoney();
    this.$store.dispatch("main/setIsShowBtn", false);
  },
  methods: {
    async tokenLogin() {
      let data = {
        token: window.localStorage.getItem("exchange_token")
      };
      let resultData = {};
      await axios.post(this.$api().tokenLogin, data).then(res => {
        resultData = res.data;
      });
      if (this.$h.isEmpty(resultData)) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else if (resultData.error) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else {
        this.$store.commit("auth/SET_USER", resultData.userData);
        this.$store.commit("auth/SET_ISLOGINED", true);
        window.localStorage.setItem(
          "exchange_token",
          resultData.userData.token
        );
      }
    },
      async getAgencies() {
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().getAgencies, data).then(res => {
        let resultData = this.$h.assign(res.data);
        this.agencies = resultData.data;
      });
    },
    async getHandMoney() {
      if (!this.todayStatisticQuery.selectedDay) {
        this.todayStatisticQuery.selectedDay = moment(new Date()).format(
          "YYYY-MM-DD"
        );
      }

      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token),
        agencyId: this.agencyId,
        day: this.todayStatisticQuery.selectedDay
      };
      this.showLoading();
      await axios.post(this.$api().getHandMoney, data).then(res => {
        let resultData = this.$h.assign(res.data);
        this.handMoneys = resultData.data;
        this.totalBankAmount = resultData.totalBankAmount;
        this.totalLocalAmount = resultData.totalLocalAmount;
        this.usdExtrAmount = resultData.usdExtrAmount;
        this.totalAmount = resultData.totalAmount;
      });
      this.hideLoading();
    },
    showLoading() {
      this.$store.dispatch("main/setLoading", true);
    },
    hideLoading() {
      this.$store.dispatch("main/setLoading", false);
    },
    exportExcel() {
      let th = ["외화"];
      for (let i = 0; i < this.handMoneys.length; i++) {
        th.push(this.handMoneys[i].country);
      }
      let jsonData = [];
      {
        let row = [];
        row.push("현재 시재금");
        for (let i = 0; i < this.handMoneys.length; i++) {
          if (this.$h.isEmpty(this.handMoneys[i].unit)) {
            row.push(
              this.$h.filterCurrency(this.handMoneys[i].handForeignAmount)
            );
          } else {
            row.push(
              this.handMoneys[i].unit +
                " " +
                this.$h.filterCurrency(this.handMoneys[i].handForeignAmount)
            );
          }
        }
        jsonData.push(row);
      }
      {
        let row = [];
        row.push("평단가");
        for (let i = 0; i < this.handMoneys.length; i++) {
          row.push(this.$h.filterCurrency(this.handMoneys[i].averageCost));
        }
        jsonData.push(row);
      }
      if (this.$store.state.auth.user.isAdmin >= 1) {
        {
          let row = [];
          row.push("환산액(원화)");
          for (let i = 0; i < this.handMoneys.length; i++) {
            row.push(
              "₩" +
                this.$h.filterCurrency(
                  parseInt(
                    this.handMoneys[i].handForeignAmount *
                      this.handMoneys[i].averageCost
                  )
                )
            );
          }
          jsonData.push(row);
        }
        {
          let row = [];
          row.push("이종통화 합계");
          row.push("₩" + this.$h.filterCurrency(this.usdExtrAmount));
          jsonData.push(row);
        }
        {
          let row = [];
          row.push("원화");
          row.push("원화:");
          row.push("₩" + this.$h.filterCurrency(this.totalLocalAmount));
          row.push("+");
          row.push("통장잔고:");
          row.push("₩" + this.$h.filterCurrency(this.totalBankAmount));
          row.push("=");
          row.push(
            "₩" +
              this.$h.filterCurrency(
                Number(this.totalLocalAmount) + Number(this.totalBankAmount)
              )
          );
          jsonData.push(row);
        }
        {
          let row = [];
          row.push("시재금 총계");
          row.push("₩" + this.$h.filterCurrency(this.totalAmount));
          jsonData.push(row);
        }
      }
      export_json_to_excel(th, jsonData, "tablePrint");
    }
  }
};
</script>
